import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import {
    REQUEST_ADD_PASSPORT,
    REQUEST_LIST_PASSPORTS,
    REQUEST_REMOVE_PASSPORT,
    REQUEST_UPDATE_PASSPORT,
    REQUEST_ADD_MAPPING,
    REQUEST_LIST_MAPPINGS,
    REQUEST_REMOVE_MAPPING,
    REQUEST_UPDATE_MAPPING,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/integration/everbridgeMsgDefinitions";
import {
    EverbridgeMapping,
    EverbridgeMappingID,
    EverbridgePassportHeader,
    EverbridgePassportID,
} from "userful-chronos-app-common-js/dist/models/integration/everbridge";
import "./everbridgeMsgReciever";

export const requestListPassports = () => {
    getGlobalStates().eventBus.sendMsg(REQUEST_LIST_PASSPORTS);
};

export const requestAddPassport = (payload: EverbridgePassportHeader) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_ADD_PASSPORT, payload);
};

export const requestUpdatePassport = (payload: EverbridgePassportHeader) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_UPDATE_PASSPORT, payload);
};

export const requestRemovePassport = (payload: EverbridgePassportID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_REMOVE_PASSPORT, payload);
};

export const requestListMappings = (passportId?: EverbridgePassportID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_LIST_MAPPINGS, passportId);
};

export const requestAddMapping = (payload: EverbridgeMapping) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_ADD_MAPPING, payload);
};

export const requestUpdateMapping = (payload: EverbridgeMapping) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_UPDATE_MAPPING, payload);
};

export const requestRemoveMapping = (payload: EverbridgeMappingID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_REMOVE_MAPPING, payload);
};

export const requestListEverbridgeData = () => {
    requestListPassports();
    requestListMappings();
};
